<template>
  <div style="background-color: #EFF6FF">
    <b-container align="center">
      <b-row>
        <b-col cols="12">세부 트랙 소개</b-col>
        <b-col cols="6">선수 과목 없음</b-col>
        <b-col cols="6">수강 시간 120시간</b-col>
      </b-row>
      <b-row>
        ul
      </b-row>
    </b-container>
    <b-container align="center">
      <b-row align-h="center">
        <b-col
          cols="6"
          style="background-color: #4C9BFF; color: white; border-radius: 50px"
        >
          <b-row>
            <b-col cols="12">Track 0</b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <h3>프로그래밍 기초</h3>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>
            본격적인 교육과정의 시작전에 계산적 사고의 기초를 닦기 위한
            과정입니다.
            <br />이는 컴퓨터 공학 외 전공생들을 위한 과정입니다
          </p>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col cols="8">
          <b-row>
            <b-col>
              <div class="circle">Intro To App Dev</div>
            </b-col>
            <b-col>
              <div class="circle">Intro To App Dev</div>
            </b-col>
            <b-col>
              <div class="circle">Intro To App Dev</div>
            </b-col>
            <b-col>
              <div class="circle">Intro To App Dev</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.circle {
  border: 2px solid red;
  background-color: #ffffff;
  height: 100px;
  border-radius: 50%;
  width: 100px;
}
</style>
